import formatPhone, { formatPhoneCopyText, formatPhoneTelHref } from "@/utils/format-phone"
import { ButtonBadge } from "@ui/button-badge"

import { useRingoutDialog } from "@/components/household/header/use-ringout-dialog"

interface PhoneBadgeWithRingoutProps {
  value?: string | null
  extension?: string | null
  name: string
}

function formatPhoneSafe(phone: string) {
  try {
    return formatPhone(phone)
  } catch {
    return phone
  }
}

function PhoneBadgeContent({ displayValue, extension }: { displayValue: string; extension?: string | null }) {
  return (
    <span className="inline-flex min-w-0 items-center">
      <span className="truncate">{displayValue}</span>
      {extension && (
        <>
          <span className="text-blue-foreground/60 mx-1">·</span>
          <span className="text-blue-foreground/70">ext {extension}</span>
        </>
      )}
    </span>
  )
}

export function PhoneBadgeWithRingout({ value, extension, name }: PhoneBadgeWithRingoutProps) {
  const { open: openRingoutDialog, hasRingout, dialog: ringoutDialog } = useRingoutDialog()

  if (!value) return <>{ringoutDialog}-</>

  const displayValue = formatPhoneSafe(value)
  const copyText = formatPhoneCopyText(value, extension)
  const telHref = formatPhoneTelHref(value, extension)
  const label = extension ? `${name} — ${displayValue} ext ${extension}` : `${name} — ${displayValue}`

  if (!hasRingout) {
    return (
      <>
        {ringoutDialog}
        <ButtonBadge text={displayValue} copyText={copyText} href={telHref}>
          <PhoneBadgeContent displayValue={displayValue} extension={extension} />
        </ButtonBadge>
      </>
    )
  }

  return (
    <>
      {ringoutDialog}
      <ButtonBadge
        text={displayValue}
        copyText={copyText}
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          openRingoutDialog({
            preSelectedPhone: value,
            preSelectedExtension: extension,
            preSelectedLabel: label,
          })
        }}
      >
        <PhoneBadgeContent displayValue={displayValue} extension={extension} />
      </ButtonBadge>
    </>
  )
}
